{
  "brand": {
    "name": "Færdo"
  },
  "landing": {
    "description": "Færd to po duńsku podróż.",
    "tagline": "Zacznij swoją następną podróż już teraz."
  },
  "locale": {
    "switchLabel": "Język",
    "en": "English",
    "pl": "Polski"
  },
  "theme": {
    "system": "Motyw systemowy",
    "dark": "Motyw ciemny",
    "light": "Motyw jasny"
  },
  "newsletter": {
    "label": "Szlak otwiera się wkrótce. Bądź pierwszy na starcie.",
    "emailPlaceholder": "Twój adres e-mail",
    "cta": "Rezerwuję miejsce",
    "sending": "Pakuję plecak…",
    "success": "Plecak spakowany. Damy Ci sygnał, gdy otworzymy szlak.",
    "error": "Coś poszło nie tak. Spróbuj ponownie."
  },
  "consent": {
    "message": "Używamy analitycznych plików cookie, aby rozumieć, jak korzystasz z tej strony i ją ulepszać. Możesz zaakceptować lub odrzucić.",
    "accept": "Akceptuj",
    "decline": "Odrzuć"
  }
}
